import { render } from "./similarMovieList.vue?vue&type=template&id=f40787da"
import script from "./similarMovieList.vue?vue&type=script&lang=js"
export * from "./similarMovieList.vue?vue&type=script&lang=js"

import "./similarMovieList.vue?vue&type=style&index=0&id=f40787da&lang=scss"

import exportComponent from "/home/runner/work/cinema_vue/cinema_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__